import { createPostEndpoint } from '@sonar-software/sonar-http';

import { DataSecurityMonitor, DataSecurityMonitorType } from '@types';

export type PostDataSecurityMonitorRequest = Omit<DataSecurityMonitor & { monitorTypeId: DataSecurityMonitorType }, 'id'>;

export const postDataSecurityMonitor = createPostEndpoint<PostDataSecurityMonitorRequest>(
	() => '/api/v3/data-security/monitors'
);
